import PeanutButterProduct from 'models/PeanutButterProduct'

export const packagingInitialState = {
  category: PeanutButterProduct.category,
  subCategory: PeanutButterProduct.subCategory,
  PBTexture: {
    value: '',
    label: 'Texture',
  },
  PBContainerSize: 16,
  otherTexture: '',
}

export const textureOptions = [
  {
    value: '',
    label: 'Texture',
    isDisabled: true,
  },
  {
    value: 'Creamy',
    label: 'Creamy',
  },
  {
    value: 'Chunky',
    label: 'Chunky',
  },
  {
    value: 'Smooth',
    label: 'Smooth',
  },
  {
    value: 'Natural',
    label: 'Natural',
  },
  {
    value: 'Other',
    label: 'Other',
  },
]
